export default __webpack_public_path__ + "static/logo-08dc12a0dfa94c5488860bfc2ef6bb93.svg";